import { render } from "./TealBox.vue?vue&type=template&id=7ded9079&scoped=true"
import script from "./TealBox.vue?vue&type=script&lang=js"
export * from "./TealBox.vue?vue&type=script&lang=js"

import "./TealBox.vue?vue&type=style&index=0&id=7ded9079&lang=scss&scoped=true"

import exportComponent from "/var/www/ascentcontrols/landingpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ded9079"]])

export default __exports__